import React, { useState } from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { clsx } from 'clsx';
const FAQS = [{
  q: '¿En qué formato se entrega el diario?',
  a: 'Puedes elegir entre la versión en PDF descargable para acceso inmediato, o la versión impresa que enviamos directamente a tu casa.'
}, {
  q: '¿Sirve si ya estoy avanzada en mi embarazo?',
  a: '¡Totalmente! El método está diseñado para que puedas empezar en cualquier momento. Si ya pasaste algunas semanas, puedes usar esas páginas para documentar recuerdos retrospectivos o enfocarte en las semanas que te quedan.'
}, {
  q: '¿Tienen garantía?',
  a: 'Sí, ofrecemos una garantía de satisfacción de 30 días. Si sientes que el método no te ayuda a conectar con tu bebé, te devolvemos tu dinero sin preguntas.'
}, {
  q: '¿En qué idioma está?',
  a: 'Todo el contenido, las guías y los bonos están 100% en español.'
}, {
  q: '¿Puedo comprarlo para regalar a otra mamá?',
  a: '¡Es el regalo perfecto! Durante el proceso de compra podrás indicar si es para ti o si deseas enviarlo como regalo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-147">
      <FadeIn data-id="element-148">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-brand-burgundy mb-10" data-id="element-149">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-150">
          {FAQS.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={clsx('border rounded-2xl overflow-hidden transition-colors duration-300', isOpen ? 'border-brand-burgundy bg-white shadow-sm' : 'border-brand-gold/30 bg-brand-cream-alt hover:border-brand-rose')} data-id="element-151">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-152">
                  <span className="font-semibold text-brand-burgundy pr-4" data-id="element-153">
                    {faq.q}
                  </span>
                  <ChevronDown className={clsx('w-5 h-5 text-brand-rose transition-transform duration-300 shrink-0', isOpen && 'rotate-180')} data-id="element-154" />
                </button>
                <div className={clsx('px-6 overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0')} data-id="element-155">
                  <p className="text-gray-600 leading-relaxed" data-id="element-156">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </FadeIn>
    </section>;
}